import Box from "@mui/material/Box";
import Wrapper from "components/LayoutFront/Wrapper";
import PropTypes from "prop-types";
import React from "react";

const History = (props) => {
  const { text = "", timelineTitle = "", timeline = null } = props;

  return (
    <>
      <Wrapper sx={{ px: { xs: 2, lg: 0 } }}>
        <h2>{timelineTitle}</h2>
      </Wrapper>
      <Wrapper
        sx={{
          display: "flex",
          flexDirection: { xs: "column", lg: "row" },
          "& > div": {
            flex: "1 1 0px",
          },
        }}
        leftProps={{ sx: { bgcolor: "var(--background-alt-grey)" } }}
      >
        <Box sx={{ bgcolor: "var(--background-alt-grey)", py: 4, pl: { xs: 2, lg: 0 }, pr: { xs: 2, lg: 6 } }}>
          {text}
        </Box>
        <Box>
          <Box sx={{ ml: { lg: -1.25 }, mt: { xs: 4, lg: 0 }, px: { xs: 2, lg: 0 } }}>{timeline}</Box>
        </Box>
      </Wrapper>
    </>
  );
};

History.propTypes = {
  text: PropTypes.node,
  timelineTitle: PropTypes.node,
  timeline: PropTypes.node,
};

export default History;
